import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Loader from "@amzn/meridian/loader";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import ErrorPage from "./utils/ErrorPage";
import Tooltip from "@amzn/meridian/tooltip";
import Box from "@amzn/meridian/box";
import {
    chainWalk,
    convertToString, extractRouteCodePrefixesFromParam,
    getFilteredLocations,
    getNodeId, isOnlyRouteViewApplicable
} from "../Utility";
import {FormattedMessage, injectIntl} from "react-intl";
import {Capability, HeatMapView, ViewType} from "../enums";
import {getLocale} from "../handler/LocaleHandler";
import Icon from "@amzn/meridian/icon";
import alertKnockoutTokens from "@amzn/meridian-tokens/base/icon/alert-knockout";
import helpKnockoutTokens from "@amzn/meridian-tokens/base/icon/help-knockout";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Column from "@amzn/meridian/column";
import {FEATURES, refreshInterval} from "../constants";
import {
    getInductPackageMetricsForOverviewAisle,
    getStowPackageMetricsForOverviewAisle,
    getInductPackageMetricsForOverviewCluster,
    getMinOfWorkMetricsForOverviewCluster,
    getStowPackageMetricsForOverviewCluster,
    getStowAssociateMetricsForOverviewCluster,
    getAtRiskAislesForOverview,
    fetchSmartStowEnablementCallSuccess,
} from "../actions/OverviewActions";
import {fetchCapabilityCallSuccess, fetchCPTList, fetchCycles, viewChanged, navigationAdded, navigationRemoved} from "../actions/OptionsActionsV2";
import StowBreakdown from "./StowBreakdown";
import ReverseSortGroupPlan from "./ReverseSortGroupPlan";
import {
    getFeaturesFromParent,
    getNodeCapabilityFromParent,
    getSmartStowEnablementFromParent
} from "../handler/ParentDataHandler";
import {fetchFeatureStatusCallSuccess} from "../actions/ConfigActions";
import RefreshTimer from "./RefreshTimer";
import {useDeviceLayout} from "./common/context/DeviceLayoutContext";


class StowOverview extends Component {


    constructor(props) {
        super(props);
        this.state = {
            nodeId: getNodeId(),
            routeCodePrefixes: extractRouteCodePrefixesFromParam(props),
            sortColumn: "aisle",
            sortDirection: "ascending",
            flag:false,
            locale:"en"
        };
    }

    timer;

    render() {
        const {navigationOptions, selectedCycle, selectedCycleId, selectedView, isInitialView, selectedCPTId, filterIdentifier} = this.props;
        //For initial view open route view when route code prefix list exists in params
        if (this.state.routeCodePrefixes && this.state.routeCodePrefixes !== "" && isInitialView) {
            this.props.dispatch(viewChanged(HeatMapView.ROUTE_VIEW))
        }
        const view = this.findViewByOptionValues(navigationOptions, selectedView);

        const renderSubComponent = () => {

            clearInterval(this.timer);

            switch (view) {
                case HeatMapView.AISLE_VIEW:
                    return <StowBreakdown/>
                case HeatMapView.SORT_ZONE_VIEW:
                    return <StowBreakdown/>
                case HeatMapView.STATION_PAIR_VIEW:
                    return <StowBreakdown/>
                case HeatMapView.FLOOR_VIEW:
                    return <StowBreakdown/>
                case HeatMapView.ROUTE_VIEW:
                    return <StowBreakdown/>
                case HeatMapView.ZONE_VIEW:
                    return <StowBreakdown/>
                case HeatMapView.CART_LOCATION_VIEW:
                    return <StowBreakdown/>
                case HeatMapView.FLOOR_LOCATION_VIEW:
                    return <StowBreakdown/>
                case ViewType.REVERSE_SORT_GROUP_PLAN_VIEW:
                    return <ReverseSortGroupPlan/>
                case HeatMapView.CLUSTER_VIEW:
                default:
                    return this.renderStowOverview(selectedCycle, selectedCycleId, selectedCPTId, filterIdentifier,this.isCPTFilterEnabled())
            }
        }
        return (
            renderSubComponent()
        )
    }

    renderStowOverview(selectedCycle, selectedCycleId, selectedCPTId, filterIdentifier, isCPTFilterEnabled){
        if (this.state.flag === false  && selectedCycle && selectedCycleId){
            this.fetchOverviewData(this.state.nodeId, selectedCycle, selectedCycleId, selectedCPTId, filterIdentifier, isCPTFilterEnabled);
            this.setState({flag: true});
        }
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.fetchOverviewData(this.state.nodeId, selectedCycle, selectedCycleId, selectedCPTId, filterIdentifier, isCPTFilterEnabled);
            }
        }, refreshInterval);
        return this.renderAtRiskAisle(selectedCycle, selectedCycleId, selectedCPTId, filterIdentifier, isCPTFilterEnabled)
    }

    fetchOverviewData(nodeId, cycle, cycleId, CPTId, filterIdentifier, isCPTFilterEnabled) {
        if ((cycle && cycleId) || (CPTId)) {
            this.props.dispatch(getMinOfWorkMetricsForOverviewCluster(nodeId, this.isDRSStowVisibilityEnabled(), [cycle], [cycleId]));
            this.props.dispatch(getAtRiskAislesForOverview(nodeId, this.isDRSStowVisibilityEnabled(), [cycle],[cycleId], [CPTId], filterIdentifier, isCPTFilterEnabled, this.props.isSmartStowEnabled));
            this.props.dispatch(getInductPackageMetricsForOverviewAisle(nodeId, [cycle], [CPTId], filterIdentifier, isCPTFilterEnabled));
            this.props.dispatch(getInductPackageMetricsForOverviewCluster(nodeId, [cycle], [CPTId], filterIdentifier, isCPTFilterEnabled));
            this.props.dispatch(getStowPackageMetricsForOverviewCluster(nodeId, this.isDRSStowVisibilityEnabled(), [cycle], [cycleId], [CPTId], filterIdentifier, isCPTFilterEnabled));
            this.props.dispatch(getStowPackageMetricsForOverviewAisle(nodeId, this.isDRSStowVisibilityEnabled(), [cycle], [cycleId], [CPTId], filterIdentifier, isCPTFilterEnabled));
            this.props.dispatch(getStowAssociateMetricsForOverviewCluster(nodeId, [cycle], [CPTId], filterIdentifier, isCPTFilterEnabled));
        }
    }

    renderAtRiskAisle() {
        const {
            loading, error, stowPackageMetricsMapAisle, stowPackageMetricsMapCluster, inductPackageMetricsMapCluster, stowAssociateMetricsMapCluster,
            atRiskAislesMetricsMap, inductPackageMetricsMapAisle
        } = this.props;

        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }

        const allAisles = [
            ...Object.keys(stowPackageMetricsMapAisle),
            ...Object.keys(atRiskAislesMetricsMap),
            ...Object.keys(inductPackageMetricsMapAisle)
        ];
        const allClusters = [
            ...Object.keys(stowPackageMetricsMapCluster),
            ...Object.keys(inductPackageMetricsMapCluster),
            ...Object.keys(stowAssociateMetricsMapCluster)
        ];

        const distinctAisles = [...new Set(allAisles)];
        const distinctClusters = [...new Set(allClusters)];

        const filteredClusters = getFilteredLocations(distinctClusters, stowPackageMetricsMapCluster, this.isDRSStowVisibilityEnabled());
        const filteredAisles = getFilteredLocations(distinctAisles, stowPackageMetricsMapAisle, this.isDRSStowVisibilityEnabled());

        if (loading && !distinctAisles.length) {
            return (
                <Column
                    height="400px"
                    alignmentHorizontal="center"
                >
                    <Loader/>
                </Column>
            );
        }

        const onSort = (sortDetails) => {
            this.setState({
                sortDirection: sortDetails.sortDirection
            })
        }
        let that=this;
        function customCompare(a, b) {
            return convertToString(a)
                .localeCompare(convertToString(b), that.state.locale, {numeric: true});
        }

        const direction = this.state.sortDirection;
        filteredAisles.sort((a1, a2) => {
            return customCompare(a1, a2)
        });

        var clusterAislesPair={};
        var filteredAtRiskAislesPair=[];
        for (const cluster of filteredClusters){
            clusterAislesPair[cluster]=filteredAisles.filter(Aisle => Aisle.startsWith(cluster));
            filteredAtRiskAislesPair.push(...this.atRiskPairMap(clusterAislesPair[cluster],clusterAislesPair[cluster].length));
        }

        filteredAtRiskAislesPair.sort((a1, a2) => {
            if (direction === "ascending") {
                return customCompare(a1[0], a2[0])
            } else {
                return customCompare(a2[0], a1[0])
            }
        });

        if (!filteredAtRiskAislesPair.length){
            return (
                <Column>
                    <RefreshTimer deps={[atRiskAislesMetricsMap]} />
                    <Column type="fill" spacingInset="small medium">
                        <Heading level={2} type="h200" alignment="left" color="primary" spacing="large" >
                            <FormattedMessage id="aisle.No Aisles at Risk" defaultMessage="No Aisles at Risk"/>
                        </Heading>
                    </Column>
                    {this.renderClusters()}
                </Column>
            )
        }

        return (
            <Column>
                <RefreshTimer deps={[atRiskAislesMetricsMap]} />
                <Column type="fill" spacingInset="small medium">
                    <Heading level={2} type="h200" alignment="left" color="error" spacing="large">
                        <Icon tokens={alertKnockoutTokens}/>
                        <Heading color="primary">
                            <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.aisles_at_risk"})}>
                                <FormattedMessage id="overview.aisles_at_risk" defaultMessage=" Aisles at Risk"/>
                            </Tooltip>
                        </Heading>
                    </Heading>
                    <Table headerRows={1} showDividers={true} showStripes={true} spacing="small" fixHeaderRows={true}
                           fixHeaderRowsFullWidth={true}
                           sortColumn={this.state.sortColumn}
                           sortDirection={this.state.sortDirection}
                           onSort={onSort}
                           data-cy={"atRiskAisleTable"}
                    >
                        {this.renderAtRiskAisleHeading()}
                        {filteredAtRiskAislesPair.map(aisles => this.renderAtRiskAisleRow(aisles))}
                    </Table>
                </Column>
                {this.renderClusters()}
            </Column>
        )
    }

    renderAtRiskAisleHeading() {

        return (
            <TableRow >

                <TableCell sortColumn="aisle" backgroundColor="secondary">
                    <FormattedMessage id="aisle.aisle" defaultMessage="Aisle"/>
                </TableCell>
                <TableCell  alignmentHorizontal="right" backgroundColor="secondary">
                    <FormattedMessage id="aisle.arrived" defaultMessage="Arrived"/>
                </TableCell>
                <TableCell  alignmentHorizontal="right" backgroundColor="secondary">
                    <FormattedMessage id="aisle.inducted" defaultMessage="Inducted"/>
                </TableCell>
                <TableCell  alignmentHorizontal="right" backgroundColor="secondary">
                    <FormattedMessage id="aisle.minutes_of_work" defaultMessage="Minutes of Work"/>
                </TableCell>
                {this.renderAdjacencyScoreColumnHeading("secondary")}
            </TableRow>
        )
    }

    renderAtRiskAisleRow(aisles) {
        const a1combinedMetricsMap = this.getCombinedMetricsMapAisle(aisles[0]);
        const a2combinedMetricsMap = this.getCombinedMetricsMapAisle(aisles[1]);
        var aisle;

        if (a2combinedMetricsMap.aisle === undefined) {
            aisle = a1combinedMetricsMap.aisle.replace("-","");

            return (

                <TableRow highlightOnHover={true} key={aisles[0]} onClick={() => this.aisleRowClicked(aisles[0][0])} data-cy={"atRiskAisleDataRow"}>

                    <TableCell backgroundColor="secondary">{aisle}</TableCell>
                    <TableCell alignmentHorizontal="right" backgroundColor="secondary">
                        {a1combinedMetricsMap.receivedPackages}
                    </TableCell>
                    <TableCell alignmentHorizontal="right" backgroundColor="secondary">
                        {a1combinedMetricsMap.currentInductedPackages}
                    </TableCell>
                    <TableCell alignmentHorizontal="right" backgroundColor="secondary">
                        {a1combinedMetricsMap.minutesOfWork}
                    </TableCell>
                    {this.renderAdjacencyScoreColumnValue("secondary", a1combinedMetricsMap)}
                </TableRow>
            )
        }
        else {
            const combinedMinOfWork = (parseFloat(a1combinedMetricsMap.minutesOfWork + a2combinedMetricsMap.minutesOfWork)).toFixed(1);
            aisle=a1combinedMetricsMap.aisle.replace("-","") + "-" + a2combinedMetricsMap.aisle.replace("-","");
            return (

                <TableRow highlightOnHover={true} key={aisles[0]} onClick={() => this.aisleRowClicked(aisles[0][0])} data-cy={"atRiskAisleDataRow"}>

                    <TableCell backgroundColor="secondary">{aisle}</TableCell>
                    <TableCell alignmentHorizontal="right" backgroundColor="secondary">
                        {this.renderAisleCount(a1combinedMetricsMap.receivedPackages, a2combinedMetricsMap.receivedPackages)}
                    </TableCell>
                    <TableCell alignmentHorizontal="right" backgroundColor="secondary">
                        {this.renderAisleCount(a1combinedMetricsMap.currentInductedPackages, a2combinedMetricsMap.currentInductedPackages)}
                    </TableCell>
                    <TableCell alignmentHorizontal="right" backgroundColor="secondary">
                        {isNaN(combinedMinOfWork)? "-":combinedMinOfWork}
                    </TableCell>
                    {this.renderAdjacencyScoreColumnValue("secondary", a1combinedMetricsMap)}
                </TableRow>
            )
        }
    }

    renderClusters(){
        const {
            loading, error, stowPackageMetricsMapCluster, inductPackageMetricsMapCluster, stowAssociateMetricsMapCluster
        } = this.props;

        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }

        const allClusters = [
            ...Object.keys(stowPackageMetricsMapCluster),
            ...Object.keys(inductPackageMetricsMapCluster),
            ...Object.keys(stowAssociateMetricsMapCluster)
        ];

        const distinctClusters = [...new Set(allClusters)];

        if (loading  && !distinctClusters.length) {
            return (
                <Column
                    height="400px"
                    alignmentHorizontal="center"
                >
                    <Loader/>
                </Column>
            );
        }

        const filteredClusters = getFilteredLocations(distinctClusters, stowPackageMetricsMapCluster, this.isDRSStowVisibilityEnabled());
        filteredClusters.sort((c1, c2) => {
            if (c1 < c2) {
                return  -1
            }
            if (c1 > c2) {
                return  1
            }
            return 0
        });

        const filteredClustersPair=this.clusterPairMap(filteredClusters,filteredClusters.length);

        return (
            <Row spacing="Xsmall" wrap="down" alignmentVertical="stretch">
                {filteredClustersPair.map((clusters) => this.renderClusterGrid(clusters))}
            </Row>
        )
    }

    renderClusterGrid(clusters){
        const {isMobile, spacingInset_shorthand3} = this.props;

        const c1=clusters[0]
        const c2=clusters[1]

        const rowWidth = isMobile ? "100%" : "";
        const boxWidth = isMobile ? "" : "550px";
        const maxBoxWidth = isMobile ? "" : "50%";

        if (c2 === undefined){
            return (
                <Row  wrap="down" width="100%" alignmentVertical="stretch" spacingInset={spacingInset_shorthand3} >
                    <Box width={boxWidth} maxWidth={maxBoxWidth} type="outline" spacingInset="small">
                        <Heading level={2} type="h200" alignment="left" spacingInset="Xsmall">
                            <FormattedMessage id="cluster.cluster" defaultMessage="Cluster"/>{" " + c1}
                        </Heading>
                        {this.renderClusterContent(c1)}
                        {this.renderClusterAisles(c1)}
                    </Box>
                </Row>
            )
        }
        else {
            return (
                <Row  wrap="down" width={rowWidth} alignmentVertical="stretch" spacingInset={spacingInset_shorthand3}>
                    <Box width={boxWidth} maxWidth={maxBoxWidth} type="outline" spacingInset="small">
                        <Heading level={2} type="h200" alignment="left" spacingInset="Xsmall">
                            <FormattedMessage id="cluster.cluster" defaultMessage="Cluster"/>{" " + c1}
                        </Heading>
                        {this.renderClusterContent(c1)}
                        {this.renderClusterAisles(c1)}
                    </Box>

                    <Box width={boxWidth} maxWidth={maxBoxWidth} type="outline" spacingInset="small">
                        <Heading level={2} type="h200" alignment="left" spacingInset="small">
                            <FormattedMessage id="cluster.cluster" defaultMessage="Cluster"/>{" " + c2}
                        </Heading>
                        {this.renderClusterContent(c2)}
                        {this.renderClusterAisles(c2)}
                    </Box>
                </Row>
            )
        }
    }

    renderClusterContent(cluster) {
        const {isMobile} = this.props;

        const combinedMetricsMap = this.getCombinedMetricsMapCluster(cluster)

        if (isMobile) {
            return (
                <Fragment>
                    <Table headerRows={1} showDividers={true} showStripes={true} spacing="small"
                           fixHeaderRowsFullWidth={true}
                           data-cy={"clusterTable"}
                    >
                        {this.renderMobileClusterHeading1()}
                        {this.renderMobileClusterRow1(combinedMetricsMap)}
                    </Table>
                    <Table headerRows={1} showDividers={true} showStripes={true} spacing="small"
                           fixHeaderRowsFullWidth={true}
                           data-cy={"clusterTable"}
                    >
                        {this.renderMobileClusterHeading2()}
                        {this.renderMobileClusterRow2(combinedMetricsMap)}
                    </Table>
                </Fragment>
            );
        }

        return (
            <Table headerRows={1} showDividers={true} showStripes={true} spacing="small"
                   fixHeaderRowsFullWidth={true}
                   data-cy={"clusterTable"}
            >
                {this.renderClusterHeading()}
                {this.renderClusterRow(combinedMetricsMap)}
            </Table>
        )
    }

    renderMobileClusterHeading1() {
        return (
            <TableRow>

                <TableCell  alignmentHorizontal="left">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.container_planned"})}>
                        <FormattedMessage id="overview.container_planned" defaultMessage="C. Planned"/>
                    </Tooltip>
                </TableCell>
                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.arrived"})}>
                        <FormattedMessage id="overview.arrived" defaultMessage="Arrived"/>
                    </Tooltip>
                </TableCell>
                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.inducted"})}>
                        <FormattedMessage id="overview.inducted" defaultMessage="Inducted"/>
                    </Tooltip>
                </TableCell>
            </TableRow>
        )
    }

    renderMobileClusterHeading2() {
        return (
            <TableRow>

                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.stow_rate"})}>
                        <FormattedMessage id="overview.stow_rate" defaultMessage="Stow rate"/>
                    </Tooltip>
                </TableCell>
                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.stowers"})}>
                        <FormattedMessage id="overview.stowers" defaultMessage="Stowers"/>
                    </Tooltip>
                </TableCell>
                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.minutes_of_work"})}>
                        <FormattedMessage id="overview.Minutes_of_Work" defaultMessage="MoW"/>
                    </Tooltip>
                </TableCell>
            </TableRow>
        )
    }

    renderClusterHeading() {

        return (
            <TableRow>

                <TableCell  alignmentHorizontal="left">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.container_planned"})}>
                        <FormattedMessage id="overview.container_planned" defaultMessage="C. Planned"/>
                    </Tooltip>
                </TableCell>
                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.arrived"})}>
                        <FormattedMessage id="overview.arrived" defaultMessage="Arrived"/>
                    </Tooltip>
                </TableCell>
                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.inducted"})}>
                        <FormattedMessage id="overview.inducted" defaultMessage="Inducted"/>
                    </Tooltip>
                </TableCell>
                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.stow_rate"})}>
                        <FormattedMessage id="overview.stow_rate" defaultMessage="Stow rate"/>
                    </Tooltip>
                </TableCell>
                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.stowers"})}>
                        <FormattedMessage id="overview.stowers" defaultMessage="Stowers"/>
                    </Tooltip>
                </TableCell>
                <TableCell  alignmentHorizontal="right">
                    <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.minutes_of_work"})}>
                        <FormattedMessage id="overview.Minutes_of_Work" defaultMessage="MoW"/>
                    </Tooltip>
                </TableCell>
            </TableRow>
        )
    }

    renderMobileClusterRow1(combinedMetricsMap) {
        return (
            <TableRow  highlightOnHover={true}   data-cy={"clusterDataRow"}>

                <TableCell  alignmentHorizontal="left">
                    {combinedMetricsMap.plannedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.receivedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.currentInductedPackages}
                </TableCell>
            </TableRow>
        )
    }

    renderMobileClusterRow2(combinedMetricsMap) {
        return (
            <TableRow  highlightOnHover={true}   data-cy={"clusterDataRow"}>

                <TableCell alignmentHorizontal="right">
                    {isFinite(parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2))  ? parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2):"-"}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.activeStowers}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.minutesOfWork}
                </TableCell>
            </TableRow>
        )
    }

    renderClusterRow(combinedMetricsMap) {
        return (
            <TableRow  highlightOnHover={true}   data-cy={"clusterDataRow"}>

                <TableCell  alignmentHorizontal="left">
                    {combinedMetricsMap.plannedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.receivedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.currentInductedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {isFinite(parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2))  ? parseFloat(combinedMetricsMap.stowRate/combinedMetricsMap.activeStowers).toFixed(2):"-"}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.activeStowers}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.minutesOfWork}
                </TableCell>
            </TableRow>
        )
    }

    renderClusterAisles(cluster){
        const {
            loading, error, stowPackageMetricsMapAisle, atRiskAislesMetricsMap, inductPackageMetricsMapAisle
        } = this.props;
        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }

        const allAisles = [
            ...Object.keys(stowPackageMetricsMapAisle),
            ...Object.keys(atRiskAislesMetricsMap),
            ...Object.keys(inductPackageMetricsMapAisle)
        ];

        const distinctAisles = [...new Set(allAisles)];

        const filteredAisles = getFilteredLocations(distinctAisles.filter((aisle) => aisle.startsWith(cluster)), stowPackageMetricsMapAisle, this.isDRSStowVisibilityEnabled());

        if (loading && !distinctAisles.length ) {
            return (
                <Column
                    height="400px"
                    alignmentHorizontal="center"
                >
                    <Loader/>
                </Column>
            );
        }
        let that=this;
        function customCompare(a, b) {
            return convertToString(a)
                .localeCompare(convertToString(b), that.state.locale, {numeric: true});
        }

        filteredAisles.sort((a1, a2) => {
            return customCompare(a1, a2)
        });

        const filteredAislePair=this.aislePairMap(filteredAisles,filteredAisles.length);

        return (
            <Box spacing="none">
                <Table headerRows={1}
                       showDividers={true}
                       showStripes={false}
                       spacing="small"
                       data-cy={"clusterAislesTable"}
                >
                    {this.renderClusterAisleHeading()}
                    {filteredAislePair.map((aisles) => this.renderClusterAisleRow(aisles))}
                </Table>
            </Box>
        )
    }

    renderClusterAisleHeading(){

        return (
            <TableRow  spacingInset="Xsmall" >

                <TableCell sortColumn="aisle" >
                    <FormattedMessage id="aisle.aisle" defaultMessage="Aisle"/>
                </TableCell>
                <TableCell  alignmentHorizontal="right" >
                    <FormattedMessage id="aisle.arrived" defaultMessage="Arrived"/>
                </TableCell>
                <TableCell  alignmentHorizontal="right" >
                    <FormattedMessage id="aisle.inducted" defaultMessage="Inducted"/>
                </TableCell>
                {this.renderAdjacencyScoreColumnHeading("default")}
                <TableCell  alignmentHorizontal="right"  >
                    <FormattedMessage id="aisle.active" defaultMessage="Active"/>
                </TableCell>
            </TableRow>
        )
    }

    renderClusterAisleRow(aisles){

        const a1combinedMetricsMap = this.getCombinedMetricsMapAisle(aisles[0]);
        const a2combinedMetricsMap = this.getCombinedMetricsMapAisle(aisles[1]);
        var aisle;
        var setcolor = "default";
        if (a2combinedMetricsMap.aisle === undefined) {
            aisle = a1combinedMetricsMap.aisle.replace("-","");
            if (a1combinedMetricsMap.minutesOfWork >15 && a1combinedMetricsMap.minutesOfWork <= 30){
                setcolor = "#DCB700";
            }
            if (a1combinedMetricsMap.minutesOfWork > 30) {
                setcolor = "#DD9DAB";
            }

        }
        else {
            const combinedMinOfWork= (parseFloat(a1combinedMetricsMap.minutesOfWork+a2combinedMetricsMap.minutesOfWork)).toFixed(1);
            aisle = a1combinedMetricsMap.aisle.replace("-","") + "-" + a2combinedMetricsMap.aisle.replace("-","");
            if (combinedMinOfWork > 15 && combinedMinOfWork <= 30) {
                setcolor = "#DCB700";
            }
            if (combinedMinOfWork > 30) {
                setcolor = "#DD9DAB";
            }
        }

        return (

            <TableRow highlightOnHover={true}  key={aisles[0]} onClick={() => this.aisleRowClicked(aisles[0][0])}  spacingInset="Xsmall"  data-cy={"clusterAislesDataRow"}>

                <TableCell backgroundColor={setcolor} alignmentHorizontal="left">{aisle}</TableCell>
                <TableCell backgroundColor={setcolor} alignmentHorizontal="right">
                    {this.renderAisleCount(a1combinedMetricsMap.receivedPackages,a2combinedMetricsMap.receivedPackages)}
                </TableCell>
                <TableCell  backgroundColor={setcolor} alignmentHorizontal="right">
                    {this.renderAisleCount(a1combinedMetricsMap.currentInductedPackages,a2combinedMetricsMap.currentInductedPackages)}
                </TableCell>
                {this.renderAdjacencyScoreColumnValue(setcolor, a1combinedMetricsMap)}
                <TableCell backgroundColor={setcolor} alignmentHorizontal="right">
                    <Tooltip position="top"  title={this.renderAlias(a1combinedMetricsMap.associateAlias,a2combinedMetricsMap.associateAlias)}>
                        <text>{this.renderAisleCount(a1combinedMetricsMap.activeStowers,a2combinedMetricsMap.activeStowers)}</text>
                    </Tooltip>
                </TableCell>
            </TableRow>
        )
    }

    componentDidMount(){
        let that=this;
        getLocale().then((locale) =>{
            that.setState({locale:locale})
        })
        getFeaturesFromParent([FEATURES.ADTA_VISIBILITY, FEATURES.DRS_STOW_VISIBILITY]).then(featureStatusResponse => {
            this.props.dispatch(fetchFeatureStatusCallSuccess(featureStatusResponse.data))
        })
        getSmartStowEnablementFromParent().then(response => {
            this.props.dispatch(fetchSmartStowEnablementCallSuccess((/true/).test(response.isSmartStowEnabled)));
        })

        getNodeCapabilityFromParent().then(capabilityResponse => {
            const capability = JSON.parse(capabilityResponse.capability);
            getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED]).then(featureStatusResponse => {
                this.props.dispatch(fetchFeatureStatusCallSuccess(featureStatusResponse.data))
            })
            if(this.props.featureStatus && this.props.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED] && Capability.AR_NEXT_GEN !== capability){
                this.props.dispatch(fetchCPTList());
            }
            else if (Capability.AR_NEXT_GEN !== capability) {
                this.props.dispatch(fetchCycles());
            }
            this.props.dispatch(fetchCapabilityCallSuccess(capabilityResponse));
        })
    }

    componentDidUpdate(prevProps,prevState) {
        const {selectedCycle, selectedCycleId} = this.props;
        if (prevProps.selectedCycle !== selectedCycle && prevProps.selectedCycleId !== selectedCycleId) {
            this.fetchOverviewData(prevState.nodeId, selectedCycle, selectedCycleId)
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        this.props.dispatch(navigationRemoved(0));
    }

    aisleRowClicked = clickedCluster => {
        this.props.dispatch(navigationAdded({
            key: 'Cluster',
            value: clickedCluster
        }))
        return
    }


    /*
     * PairMap function implements pairng of aisle as per odd|even standard
     *      if (last single aisle || first even aisle)
     *          add aisle
     *      else
     *          if (firstEvenInPair)  // handle even|odd and even|even case
     *              add aisle
     *          else if (secondOddInPair) // handle odd|odd case
     *              add aisle
     *          add aisle pair
     *
     */
    atRiskPairMap (filteredAisles, totalAisles) {

        var filteredAislePair=[];
        for (var index = 0; index < totalAisles; index += 1) {
            if (index + 1 === totalAisles || (parseInt(filteredAisles[index].substring(1,filteredAisles[index].length),10)%2===0 && index ===0)) {
                const a1combinedMetricsMap = this.getCombinedMetricsMapAisle(filteredAisles[index]);
                if (a1combinedMetricsMap.minutesOfWork >30){
                    filteredAislePair.push([filteredAisles[index]]);
                }

            }
            else {
                const a1combinedMetricsMap = this.getCombinedMetricsMapAisle(filteredAisles[index]);
                const a2combinedMetricsMap = this.getCombinedMetricsMapAisle(filteredAisles[index + 1]);

                if (parseInt(filteredAisles[index].substring(1,filteredAisles[index].length),10)%2===0) {
                    if (a1combinedMetricsMap.minutesOfWork >30){
                        filteredAislePair.push([filteredAisles[index]]);
                    }
                    continue;
                }
                else if ((parseInt(filteredAisles[index+1].substring(1,filteredAisles[index+1].length),10)%2!==0)){
                    if (a1combinedMetricsMap.minutesOfWork >30){
                        filteredAislePair.push([filteredAisles[index]]);
                    }
                    continue;
                }

                const combinedMinOfWork = (parseFloat(a1combinedMetricsMap.minutesOfWork + a2combinedMetricsMap.minutesOfWork)).toFixed(1);
                if (combinedMinOfWork > 30) {
                    filteredAislePair.push([filteredAisles[index], filteredAisles[index + 1]]);
                }
                index+=1;
            }
        }
        return filteredAislePair;
    }

    aislePairMap (filteredAisles, totalAisles) {
        var filteredAislePair=[];
        for (var index = 0; index < totalAisles; index += 1) {

            if (index + 1 === totalAisles || (parseInt(filteredAisles[index].substring(1,filteredAisles[index].length),10)%2===0 && index ===0) ) {
                filteredAislePair.push([filteredAisles[index]]);
            }
            else {
                if  (parseInt(filteredAisles[index].substring(1,filteredAisles[index].length),10)%2 === 0) {
                    filteredAislePair.push([filteredAisles[index]]);
                    continue;
                }
                else if (parseInt(filteredAisles[index+1].substring(1,filteredAisles[index+1].length),10)%2 !== 0) {
                    filteredAislePair.push([filteredAisles[index]]);
                    continue;
                }
                filteredAislePair.push([filteredAisles[index], filteredAisles[index + 1]]);
                index+=1;
            }
        }
        return filteredAislePair;
    }

    clusterPairMap(filteredClusters, totalClusters) {
        var filteredClusterPair=[];
        for (var index = 0; index < totalClusters; index += 1) {
            if (index + 1 === totalClusters) {
                filteredClusterPair.push([filteredClusters[index]]);
            }
            else {
                filteredClusterPair.push([filteredClusters[index], filteredClusters[index + 1]]);
                index+=1;
            }
        }
        return filteredClusterPair;
    }

    getCombinedMetricsMapCluster = cluster => {
        const {
            stowPackageMetricsMapCluster, minOfWorkMetricsMapCluster, inductPackageMetricsMapCluster, stowAssociateMetricsMapCluster
        } = this.props;
        const defaultMetricValue = "-"
        return {
            cluster: cluster,
            plannedPackages: chainWalk(() => stowPackageMetricsMapCluster[cluster].plannedPackages, defaultMetricValue),
            receivedPackages: chainWalk(() => inductPackageMetricsMapCluster[cluster].receivedPackages, defaultMetricValue),
            currentInductedPackages: chainWalk(() => stowPackageMetricsMapCluster[cluster].currentInductedPackages, defaultMetricValue),
            stowRate: chainWalk(() => stowPackageMetricsMapCluster[cluster].stowRate, defaultMetricValue),
            minutesOfWork: chainWalk(() => isNaN(parseFloat(minOfWorkMetricsMapCluster[cluster].minutesOfWork).toFixed(1)) ? defaultMetricValue:parseFloat(minOfWorkMetricsMapCluster[cluster].minutesOfWork).toFixed(1), defaultMetricValue),
            activeStowers: chainWalk(() => stowAssociateMetricsMapCluster[cluster].activeStowers, defaultMetricValue)
        }
    }

    getMinutesOfWorkForGivenAisle(aisle) {
        const defaultMetricValue = "-";
        const { minOfWorkMetricsMapCluster, stowAssociateMetricsMapCluster, stowPackageMetricsMapAisle } = this.props;
        let cluster = aisle.charAt(0).toUpperCase();
        const lastFifteenMinuteStowRate = parseFloat(chainWalk(() => minOfWorkMetricsMapCluster[cluster].lastFifteenMinuteStowRate, defaultMetricValue)).toFixed(1);
        const activeStowers = parseFloat(chainWalk(() => stowAssociateMetricsMapCluster[cluster].activeStowers, defaultMetricValue)).toFixed(1);
        const stowRatePerStower = (lastFifteenMinuteStowRate/activeStowers).toFixed(1);
        if(!isFinite(stowRatePerStower)) {
            return "-";
        }
        const currentInductedPackage = parseFloat(stowPackageMetricsMapAisle[aisle].currentInductedPackages).toFixed(1);
        const minutesOfWork = parseFloat((currentInductedPackage*60.0)/stowRatePerStower).toFixed(1);
        if(!isFinite(minutesOfWork)) {
            return "-";
        }
        return parseFloat(minutesOfWork);
    }

    getCombinedMetricsMapAisle = aisle => {
        const { atRiskAislesMetricsMap, inductPackageMetricsMapAisle, stowPackageMetricsMapAisle } = this.props;
        const defaultMetricValue = "-"
        return {
            aisle: aisle,
            isAtRisk: chainWalk(() => atRiskAislesMetricsMap[aisle].isAtRisk, defaultMetricValue),
            minutesOfWork:  chainWalk(() => this.getMinutesOfWorkForGivenAisle(aisle), defaultMetricValue),
            adjacencyScore: chainWalk(() => atRiskAislesMetricsMap[aisle].adjacencyScore, defaultMetricValue),
            baselineAdjacencyScore: chainWalk(() => atRiskAislesMetricsMap[aisle].baselineAdjacencyScore, defaultMetricValue),
            associateAlias:  chainWalk(() => ((atRiskAislesMetricsMap[aisle].associateAlias).toString()).substring(0,((atRiskAislesMetricsMap[aisle].associateAlias).toString()).lastIndexOf('@')),defaultMetricValue),//.tostring().substring(0,4), defaultMetricValue),
            activeStowers: chainWalk(() => atRiskAislesMetricsMap[aisle].activeStowers, defaultMetricValue),
            receivedPackages: chainWalk(() => inductPackageMetricsMapAisle[aisle].receivedPackages, defaultMetricValue),
            currentInductedPackages:  chainWalk(() => stowPackageMetricsMapAisle[aisle].currentInductedPackages, defaultMetricValue)
        }
    }

    renderAisleCount = (value1, value2) => {
        return value1 === "-" ? (value2 === "-" ? "-":value2 ): (value2 === "-" ? value1:value1+value2);
    }

    renderAdjacencyScoreValue = (value1) => {
        return value1 === "-" ? "-": parseFloat(value1).toFixed(2);
    }

    renderAlias = (value1, value2) => {
        return value1 === "-" ? (value2 === "-" ? "-":value2 ): (value2 === "-" ? value1:(value1===value2 ? value1:value1+","+value2));
    }

    isADTAVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.ADTA_VISIBILITY];
    }

    isDRSStowVisibilityEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.DRS_STOW_VISIBILITY];
    }

    isCPTFilterEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED];
    }

    /* Show the alert icon if the aisle adjacency score is higher than the baseline adjacency score */
    renderAdjacencyScoreAlert = (baselineAdjacencyScore, aisleAdjacencyScore) => {
        return (aisleAdjacencyScore > (1.2 * baselineAdjacencyScore)) ? <Icon tokens={alertKnockoutTokens} /> : <text/>;
    }

    /* Show the info icon with tooltip in the table heading */
    renderAdjacencyScoreInfo = () => {
        return (
            <Tooltip position={"top"} title={this.props.intl.formatMessage({id: "tooltip.overview.adjacency_score"})}>
                <Icon tokens={helpKnockoutTokens} />
            </Tooltip>
        );
    }

    /* Add the table cell in aisle heading only if smart stow is enabled */
    renderAdjacencyScoreColumnHeading = (backgroundColor) => {
        return (this.props.isSmartStowEnabled) ? (
            <TableCell  alignmentHorizontal="right" backgroundColor={backgroundColor}>
                <FormattedMessage id="overview.adjacency_score" defaultMessage="Stow Adherence"/>
                <text> {this.renderAdjacencyScoreInfo()}</text>
            </TableCell>
        ) : null;
    }

    /* Add the table cell in row only if smart stow is enabled based on value of first aisle in pairing */
    renderAdjacencyScoreColumnValue = (backgroundColor, a1combinedMetricsMap) => {
        return (this.props.isSmartStowEnabled) ? (
            <TableCell  backgroundColor={backgroundColor} alignmentHorizontal="right">
                <text>{this.renderAdjacencyScoreAlert(a1combinedMetricsMap.baselineAdjacencyScore, a1combinedMetricsMap.adjacencyScore)} </text>
                <text>{this.renderAdjacencyScoreValue(a1combinedMetricsMap.adjacencyScore)}</text>
            </TableCell>
        ) : null;
    }

    findViewByOptionValues = (navigationOptions, selectedView) => {
        switch (this.props.capability) {
            case Capability.SSD:
                return this.findViewForSSD(navigationOptions, selectedView)
            case Capability.AMZL:
            default:
                return this.findViewForAmzlCore(navigationOptions, selectedView);
            case Capability.AR_NEXT_GEN:
                return this.findViewForArNextGen(navigationOptions, selectedView);
        }
    }

    findViewForAmzlCore = (navigationOptions, selectedView) => {
        if (ViewType.REVERSE_SORT_GROUP_PLAN_VIEW === selectedView) return ViewType.REVERSE_SORT_GROUP_PLAN_VIEW;
        if (ViewType.SIDELINE_VIEW === selectedView) return HeatMapView.FLOOR_LOCATION_VIEW;
        if (isOnlyRouteViewApplicable(this.state.nodeId, this.props.capability) || ViewType.ROUTE_VIEW === selectedView) {
            return HeatMapView.ROUTE_VIEW
        }
        else if (navigationOptions.length === 2) return HeatMapView.SORT_ZONE_VIEW;
        else if (navigationOptions.length === 1) return HeatMapView.AISLE_VIEW;
        else return HeatMapView.CLUSTER;
    }

    findViewForSSD = (navigationOptions, selectedView) => {
        if (ViewType.REVERSE_SORT_GROUP_PLAN_VIEW === selectedView) return ViewType.REVERSE_SORT_GROUP_PLAN_VIEW;
        if (ViewType.ROUTE_VIEW === selectedView) {
            return HeatMapView.ROUTE_VIEW
        }
        if(navigationOptions.length === 1) return HeatMapView.CART_LOCATION_VIEW
        return HeatMapView.ZONE_VIEW
    }

    findViewForArNextGen = (navigationOptions, selectedView) => {
        if (ViewType.REVERSE_SORT_GROUP_PLAN_VIEW === selectedView) return ViewType.REVERSE_SORT_GROUP_PLAN_VIEW;
        if (ViewType.ROUTE_VIEW === selectedView) {
            return HeatMapView.ROUTE_VIEW
        }
        if (navigationOptions.length === 1) return HeatMapView.FLOOR_VIEW;
        else return HeatMapView.STATION_PAIR_VIEW;
    }
}

// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent) {
    return function WrappedComponent(props) {
        const {isMobile, spacingInset_shorthand3} = useDeviceLayout();
        return <CustomComponent {...props} isMobile={isMobile} spacingInset_shorthand3={spacingInset_shorthand3}/>
    }
}

const mapStateToProps = state => ({
    loading: state.overviewReducer.loading,
    error: state.overviewReducer.error,
    capability: state.optionsReducerV2.capability,
    filterIdentifier: state.optionsReducerV2.filterIdentifier,
    selectedCycle: state.optionsReducerV2.options.cycle,
    selectedView: state.optionsReducerV2.heatMapView,
    selectedCycleId: state.optionsReducerV2.options.cycleId,
    selectedCPTId: state.optionsReducerV2.options.CPTId,
    isInitialView: state.optionsReducerV2.isInitialView,
    featureStatus: state.configReducer.featureStatus,
    options: state.optionsReducerV2.options,
    navigationOptions: state.optionsReducerV2.navigationOptions,
    atRiskAislesMetricsMap:state.overviewReducer.atRiskAislesMetricsMap,
    minOfWorkMetricsMapCluster: state.overviewReducer.minOfWorkMetricsMapCluster,
    stowPackageMetricsMapCluster: state.overviewReducer.stowPackageMetricsMapCluster,
    inductPackageMetricsMapCluster: state.overviewReducer.inductPackageMetricsMapCluster,
    stowAssociateMetricsMapCluster: state.overviewReducer.stowAssociateMetricsMapCluster,
    inductPackageMetricsMapAisle:state.overviewReducer.inductPackageMetricsMapAisle,
    stowPackageMetricsMapAisle:state.overviewReducer.stowPackageMetricsMapAisle,
    isSmartStowEnabled: state.overviewReducer.isSmartStowEnabled,

});
export default injectIntl(withRouter(connect(mapStateToProps)(classToFunctionAdapter(StowOverview))));



// WEBPACK FOOTER //
// ./src/components/StowOverview.js